import React, { Component } from "react";
import camIcon from "../img/cam-icon.png";
import truckIcon from "../img/truck-icon.png";
import supportIcon from "../img/support-icon.png";
import morePic from "../img/more.jpg";
import kPic from "../img/4k.jpg";
import videosPic from "../img/technicians.jpg";
import lensPic from "../img/lenses.jpg";
import megaPic from "../img/high-mega.jpg";
import fastPic from "../img/highqualityaudio.jpg";
import grip from "../img/5tontruck.jpg";
import slider1 from "../img/hireusnow.jpg";
import slider2 from "../img/lightitup.jpg";
import slider3 from "../img/bg.jpg";
import slider5 from "../img/joinustoday.jpg";
import pdf from "../img/stareway-truck-packages.pdf";
import Slice from "./Slice";
import Slick from "react-slick";
import { Link } from "react-router-dom";
import { inject, observer } from "mobx-react";

@inject("ProductStore")
@observer
class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSlide: 0,
      slices: [
        {
          img: kPic,
          name: "4K & Beyond",
          id: "5b969c655b68e21ba2f5a672",
          active: true
        },
        {
          id: "5b969c8c5b68e21ba2f5a676",
          img: lensPic,
          name: "Cinematic Lenses",
          active: false
        },
        {
          id: "5b969ca95b68e21ba2f5a677",
          img: fastPic,
          name: "High Quality Audio Equipment",
          active: false
        },
        {
          id: "5b969cbb5b68e21ba2f5a678",
          img: megaPic,
          name: " Professional Lighting Equipment",
          active: false
        },
        {
          id: "5b969cc85b68e21ba2f5a679",
          img: grip,
          name: "5 Ton Grip Truck",
          active: false
        },
        {
          id: "5b969cd85b68e21ba2f5a67a",
          img: videosPic,
          name: "Highly trained technicians",
          active: false
        },
        {
          id: "5b969ce25b68e21ba2f5a67b",
          img: morePic,
          name: "More",
          active: false
        }
      ]
    };
  }

  componentDidMount() {
    this.props.ProductStore.getFeaturedProducts();
  }

  selectSlice(key) {
    const slices = this.state.slices.map((slice, sliceKey) => ({
      ...slice,
      active: key === sliceKey
    }));
    console.log(slices);
    this.setState({
      slices
    });
  }

  render() {
    const settings = {
      autoplay: true,
      autoplaySpeed: 5000,
      dots: true,
      arrows: true,
      draggable: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            dots: true,
            adaptiveHeight: true,
            arrows: false
          }
        }
      ]
    };
    return (
      <div>
        <header>
          <Slick className="header-slick" {...settings}>
            <div
              className="header-slide"
              style={{ backgroundImage: `url(${slider3})` }}
            >
              <div className="header-title">
                <h1>Rent our 5-Ton Grip Truck</h1>
                <p>AND GET YOUR PROJECT GOING</p>
                <div className="btns-holder">
                  <a href={pdf} target="_blank">
                    <button>GRIP TRUCK PACKAGES PDF</button>
                  </a>
                  <Link to="/Shop">
                    <button>GO TO GEAR</button>
                  </Link>
                </div>
              </div>
            </div>
            <div
              className="header-slide"
              style={{ backgroundImage: `url(${slider2})` }}
            >
              <div className="header-title">
                <h1>LIGHT IT UP</h1>
                <p>FIND THE RIGHT LIGHTING FOR YOUR PROJECT</p>
                <div className="btns-holder">
                  <Link to="/about">
                    <button>LEARN MORE</button>
                  </Link>
                  <Link to="/Shop">
                    <button>GO TO GEAR</button>
                  </Link>
                </div>
              </div>
            </div>
            <div
              className="header-slide"
              style={{ backgroundImage: `url(${slider1})` }}
            >
              <div className="header-title">
                <h1>WE PROVIDE THE GEAR</h1>
                <p>YOU PROVIDE THE VISION</p>
                <div className="btns-holder">
                  <Link to="/about">
                    <button>MORE INFORMATION</button>
                  </Link>
                  <Link to="/location">
                    <button>CONTACT US</button>
                  </Link>
                </div>
              </div>
            </div>
            <div
              className="header-slide"
              style={{ backgroundImage: `url(${slider5})` }}
            >
              <div className="header-title">
                <h1>JOIN US TODAY</h1>
                <p>TO BE TRAINED BY OUR BEST PROFESSIONALS</p>
                <div className="btns-holder">
                  <Link to="/about">
                    <button>LEARN MORE</button>
                  </Link>
                  <Link to="/location">
                    <button>CONTACT US</button>
                  </Link>
                </div>
              </div>
            </div>
          </Slick>
        </header>

        <div className="main-content">
          <div className="features-boxes">
            <div className="feat-box">
              <img src={camIcon} alt="" />
              <p className="feat-title">Professional Gear</p>
              <p>We stock up on the industry’s favorite brands.</p>
              <Link to="/Shop">
                <div className="blue-o-btn">Gear</div>
              </Link>
            </div>
            <div className="feat-box">
              <img src={truckIcon} alt="" />
              <p className="feat-title">Easy Delivery</p>
              <p>We ship anywhere within Texas, right to your door.</p>
              <Link to="/Location">
                <div className="blue-o-btn">Locations</div>
              </Link>
            </div>
            <div className="feat-box">
              <img src={supportIcon} alt="" />
              <p className="feat-title">Give Us a Call</p>
              <p>Our staff has the know-how to answer any of your questions.</p>
              <Link to="/location">
                <div className="blue-o-btn">Contact Us</div>
              </Link>
            </div>
          </div>

          <div className="section-title">
            <p>FEATURED</p>
            <div className="sep" />
          </div>

          <div className="feat-slider">
            <Slick
              autoplay={true}
              autoplaySpeed={5000}
              dots={true}
              arrows={true}
              fade={true}
              draggable={false}
              className="feat-views-holder"
              ref="featuredSlider"
              afterChange={key => {
                this.setState({
                  activeSlide: key
                });
              }}
            >
              {this.props.ProductStore.featuredProducts.map(product => (
                <Link to={"shop/" + product._id}>
                  <div className="feat-view">
                    <img src={product.images[0]} className="feat-cam" alt="" />
                    <div className="feat-specs">
                      <div className="feat-title">
                        <p className="primary">{product.name}</p>
                        {/* <p className="secondary">with 24-105mm f/4L II Lens</p> */}
                      </div>
                      <div className="secondary-title">
                        <p>PRODUCT HIGHLIGHTS</p>
                        <span className="sep-border" />
                      </div>
                      <div className="specs">
                        <ul>
                          {product.specs.slice(0, 5).map(spec => (
                            <li>{spec}</li>
                          ))}
                        </ul>
                      </div>
                      <div className="feat-cost">
                        <p>
                          ${product.pricePerDay.toFixed(2)}
                          <span class="day-unit">/Day</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </Link>
              ))}
            </Slick>
            <div className="feat-list">
              <div className="section-title">
                <p>FEATURED ITEMS</p>
                <div className="sep" />
              </div>
              <div className="list">
                {this.props.ProductStore.featuredProducts.map(
                  (product, key) => (
                    <div
                      className={
                        "entry" +
                        (this.state.activeSlide === key ? " active" : "")
                      }
                      onClick={() => this.refs.featuredSlider.slickGoTo(key)}
                    >
                      <img src={product.images[0]} alt="" />
                      <div className="feat-details">
                        <p>{product.name}</p>
                        <div className="pricing">
                          <p>7 days</p>
                          <p>${(product.pricePerDay * 2.95).toFixed(2)}</p>
                        </div>
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
          </div>

          <div className="section-title">
            <p>OUR DEMO REEL</p>
            <div className="sep" />
          </div>
          <div className="demoreel">
            <div className="vid-box" style={{ width: "100%", height: "100vh" }}>
              <iframe
                src="https://player.vimeo.com/video/291126525"
                width="100%"
                height="100%"
                title="vimeo-player"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
              />
            </div>
          </div>

          <div className="section-title">
            <p>WHAT WE OFFER</p>
            <div className="sep" />
          </div>
          <div className="offers-wall">
            <div className="categories-container">
              {this.state.slices.map((slice, key) => (
                <Slice
                  {...slice}
                  onRequest={this.selectSlice.bind(this, key)}
                />
              ))}
            </div>
            <Link to="/Shop">
              <button className="blue-o-btn">ALL GEAR</button>
            </Link>
          </div>
        </div>
        <div className="partners">
          <div className="partners-title">
            <p>OUR WORK PARTNERS</p>
          </div>
          <div className="partners-holder">
            <a href="http://oscargch.com/" className="single-partner">
              Oscar Garcia Chavez
            </a>
            -
            <a href="https://www.axolotl.me/" className="single-partner">
              Axolotl Motion Design
            </a>
            -
            <a href="https://www.fiilex.com/ " className="single-partner">
              Fiilex
            </a>
            -
            <a href="http://www.jandrocisneros.com/" className="single-partner">
              Jandro Cisneros Film Score Composer
            </a>
            -
            <a
              href="https://www.cortevideo.com/
              "
              className="single-partner"
            >
              Corte Video
            </a>
          </div>
        </div>
      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js